// extracted by mini-css-extract-plugin
module.exports = {"Form":"Feedback__Form_2fPLv","Button":"Feedback__Button_14EGf"};